// busca e filtro da árvore Fabricante → Função → Modelo; extraído de
// pages/templates/index.js pra reuso no diálogo de aplicação em massa
const DIACRITICOS = new RegExp("[\\u0300-\\u036f]", "g");

export const normalizeText = (text) =>
    (text || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(DIACRITICOS, "");

// fabricantes filtrados (busca em fabricante / função / modelo)
export function filterFabricantes(fabricantesArr, termo) {
    const q = normalizeText(termo);
    if (!q) return fabricantesArr;
    return (fabricantesArr || [])
        .map((fab) => {
            const fabMatch = normalizeText(fab.fabricante).includes(q);
            const Funcoes = (fab.Funcoes || [])
                .map((fun) => {
                    const funMatch = normalizeText(fun.funcao || fun.nome).includes(q);
                    const Modelos = (fun.Modelos || []).filter((mod) =>
                        normalizeText(mod.modelo).includes(q)
                    );
                    if (funMatch || Modelos.length > 0) {
                        return { ...fun, Modelos: funMatch ? fun.Modelos : Modelos };
                    }
                    return null;
                })
                .filter(Boolean);
            if (fabMatch || Funcoes.length > 0) {
                return { ...fab, Funcoes: fabMatch ? fab.Funcoes : Funcoes };
            }
            return null;
        })
        .filter(Boolean);
}

// ignora nós placeholder (id null) deixados por deleteFabricante / removeNode
export function idsDosModelos(fabricantesArr) {
    const ids = [];
    for (const fab of fabricantesArr || []) {
        if (!fab || fab.id == null) continue;
        for (const fun of fab.Funcoes || []) {
            if (!fun || fun.id == null) continue;
            for (const mod of fun.Modelos || []) {
                if (mod && mod.id != null) ids.push(mod.id);
            }
        }
    }
    return ids;
}
